import React from "react";
import { Popover } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

export const strToFloat = (string) => {
  const float = parseFloat(string);
  if (float) {
    return float;
  } else {
    return 0;
  }
};

export const formatNumber = (number) => {
  if (!isValid(number) || number === undefined || number === "") {
    return "0.00";
  }

  let numStr = parseFloat(number).toFixed(2);
  let negative;
  if (numStr[0] === "-") {
    // number is negative
    negative = "-";
    numStr = numStr.slice(1);
  } else {
    negative = "";
  }

  // split before and after decimal point
  const parts = numStr.split(".");

  if (parts[0].length > 3) {
    // add commas
    const numCommas = Math.floor((parts[0].length - 1) / 3);
    for (let i = 0; i < numCommas; i++) {
      parts[0] = parts[0].slice(0, -3 * (i + 1) - i) + "," + parts[0].slice(-3 * (i + 1) - i);
    }
  }

  // adding 0 or rounding depending on length
  if (parts[1]) {
    if (parts[1].length === 1) {
      parts[1] = parts[1] + "0";
    } else if (parts[1].length > 2) {
      if (parts[1][2] >= 5) {
        parts[1] = parts[1][0] + (parseFloat(parts[1][1]) + 1).toString();
      }
    }
    parts[1] = parts[1].slice(0, 2);
  }

  numStr = negative + parts[0] + "." + parts[1];
  return numStr;
};

export const getLabel = (labelText, tooltip = "") => {
  if (tooltip) {
    return (
      <Popover trigger="hover" content={tooltip} placement="bottom" overlayStyle={{ maxWidth: 400 }}>
        {<InfoCircleOutlined style={{ color: "#d6001c" }} />}
        {" " + labelText}
      </Popover>
    );
  }
  return labelText;
};

export const isValid = (str) => {
  if (str === "" || str === undefined){
    return true //Blank or missing fields are allowed
  }
  return !isNaN(str) && !isNaN(parseFloat(str)) && parseFloat(str) >= 0
}

export const getHelp = (input) => {
  if (isValid(input)) {
    return ("")
  } else {
    return ("Invalid Number!")
  }
}

export const getValidateStatus = (input) => {
  if (isValid(input)) {
    return ("")
  } else {
    return ("error")
  }
}

export const currencyList = [
  "BGN",
  "CHF",
  "CZK",
  "DKK",
  "EUR",
  "GBP",
  "HRK",
  "GEL",
  "HUF",
  "NOK",
  "PLN",
  "RUB",
  "RON",
  "SEK",
  "TRY",
  "UAH",
  "AED",
  "ILS",
  "KES",
  "MAD",
  "NGN",
  "ZAR",
  "BRL",
  "CAD",
  "CLP",
  "COP",
  "MXN",
  "PEN",
  "USD",
  "AUD",
  "BDT",
  "CNY",
  "HKD",
  "IDR",
  "INR",
  "JPY",
  "MYR",
  "NZD",
  "PHP",
  "PKR",
  "SGD",
  "KRW",
  "LKR",
  "THB",
  "VND",
].sort();
